// extracted by mini-css-extract-plugin
export var bubble = "_10-0";
export var container = "_10-3";
export var contrastBorder = "_10-4";
export var greyOut = "_10-2";
export var initialsWrapper = "_10-1";
export var large = "_10-9";
export var medium = "_10-8";
export var mediumSmall = "_10-7";
export var mediumSmallMedium = "_10-c";
export var micro = "_10-5";
export var small = "_10-6";
export var tiny = "_10-b";
export var xTiny = "_10-a";